import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-rejection-reason-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule
  ],
  template: `
    <div class="rejection-dialog" style="padding: 20px; min-width: 400px;">
      <h2 mat-dialog-title style="display: flex; align-items: center; gap: 10px; margin-bottom: 20px; color: #d32f2f;">
        <mat-icon>report_problem</mat-icon>
        {{ data?.title || 'Reason for Rejection' }}
      </h2>
      
      <mat-dialog-content>
        <p style="color: #666; margin-bottom: 20px;">
          {{ data?.label || 'Please provide a reason for rejecting this document.' }}
        </p>
        
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Rejection Reason</mat-label>
          <textarea 
            matInput 
            [(ngModel)]="reason" 
            placeholder="E.g., Price is too high, Delivery time not suitable..."
            rows="4"
            required
          ></textarea>
          <mat-icon matSuffix>edit_note</mat-icon>
        </mat-form-field>
      </mat-dialog-content>
      
      <mat-dialog-actions align="end" style="margin-top: 20px; gap: 10px;">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button 
          mat-flat-button 
          color="warn" 
          (click)="onSubmit()" 
          [disabled]="!reason.trim()"
        >
          {{ data?.buttonText || 'Reject' }}
        </button>
      </mat-dialog-actions>
    </div>
  `
})
export class RejectionReasonDialogComponent {
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<RejectionReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSubmit(): void {
    if (this.reason.trim()) {
      this.dialogRef.close(this.reason.trim());
    }
  }
}
